import { useMutation, useQuery } from 'react-query';
import {
  skipTransferLedgerMapping,
  submitTransferLedgerMapping,
  getTransferLedgerMappingActions,
} from '~/api/transfers';

export const useGetTransferActions = (transferId: string, hasPermissions: boolean) => {
  return useQuery(
    ['ledgerMappingActions', transferId],
    () => getTransferLedgerMappingActions(transferId),
    {
      enabled: !!transferId && !!hasPermissions,
    }
  );
};

interface ActionProps {
  onSuccess: () => void;
  transferId: string;
  system: string;
}

export const useSkip = (props: ActionProps) => {
  const { onSuccess, transferId, system } = props;
  return useMutation(() => skipTransferLedgerMapping(transferId, system), {
    onSuccess() {
      onSuccess();
    },
  });
};

export const useSubmit = (props: ActionProps) => {
  const { onSuccess, transferId, system } = props;
  return useMutation(() => submitTransferLedgerMapping(transferId, system), {
    onSuccess() {
      onSuccess();
    },
  });
};
